import React, { useEffect } from 'react';

export default function BounceLoaderOverlay({ visible }) {
  useEffect(() => {
    // Insert keyframes only once
    if (typeof window !== 'undefined' && !document.getElementById('bounce-keyframes')) {
      const styleSheet = document.createElement('style');
      styleSheet.id = 'bounce-keyframes';
      styleSheet.type = 'text/css';
      styleSheet.innerText = `
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scaleY(0.4);
          }
          40% {
            transform: scaleY(1);
          }
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  if (!visible) return null;

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontSize: 18,
    fontWeight: 500,
    zIndex: 20,
    userSelect: 'none',
    gap: 20,
    textAlign: 'center',
  };

  const bounceContainerStyle = {
    display: 'flex',
    gap: 8,
    alignItems: 'flex-end',
    height: 40,
  };

  const bounceStyle = (delay) => ({
    width: 12,
    height: 40,
    backgroundColor: '#4ade80',
    borderRadius: 6,
    animation: `bounce 1.4s infinite ease-in-out`,
    animationDelay: `${delay}s`,
  });

  const textStyle = {
    marginTop: 10,
  };

  return (
    <div style={overlayStyle}>
      <div style={bounceContainerStyle}>
        <div style={bounceStyle(0)} />
        <div style={bounceStyle(0.2)} />
        <div style={bounceStyle(0.4)} />
      </div>
      <div style={textStyle}>The Coach is getting ready to start interacting with you...</div>
    </div>
  );
}
